import React, { Fragment, useCallback, useRef, useState } from "react";
import { useContext } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import * as XLSX from "xlsx";
import { isValidArray, scrollToTop } from "../../../Layout/Common/common";
import { ErrorItem } from "../ErrorItem";
import { excelUpload } from "../../../assets/imageImport";
import { SuccessMessageContainer } from "../../../Layout/Common/alert/SuccessMessageContainer";
import { useNavigate } from "react-router-dom";
import { Button } from "bootstrap";

export const QuickOrderExcel = ({ AddtoCart, onSuccessClose }) => {
  const globalcontext = useContext(GlobalContext);
  const [jsonData, setJsonData] = useState([]);
  const [errorItem, setErrorItem] = useState(null);
  const [fileError, setFileError] = useState(null);
  const fileInputRef = useRef(null);
  const requiredColumns = ["Code", "Quantity"];
  const successMessageRef = useRef(null);
  const [isAdding, setIsAdding] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const navigate = useNavigate();

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFileError(null);
        setErrorItem(null);
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];

        // Try to parse with header row first
        let jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonData.length === 0) {
          setFileError("The file is empty or invalid.");
          setJsonData(null);
          return;
        }

        let headers = jsonData[0];
        let dataRows = [];
        // Check if header row contains 'Code' and 'Quantity' (case-insensitive)
        const headerHasCode = headers.some((h) => String(h).toLowerCase() === "code");
        const headerHasQty = headers.some((h) => String(h).toLowerCase() === "quantity");

        if (headerHasCode && headerHasQty) {
          // File has header row, map as before
          dataRows = jsonData
            .slice(1)
            .map((row) => {
              const hasValue = row.some((cell) => cell != null && cell != undefined && String(cell).trim() !== "");
              if (!hasValue) return null;
              return headers.reduce((acc, header, index) => {
                acc[header] = row[index];
                return acc;
              }, {});
            })
            .filter(Boolean);
        } else {
          // No header row, treat first row as data, columns A/B as Code/Quantity
          dataRows = jsonData
            .map((row) => {
              if (!Array.isArray(row)) return null;
              const code = row[0];
              const qty = row[1];
              const hasValue =
                (code != null && String(code).trim() !== "") || (qty != null && String(qty).trim() !== "");
              if (!hasValue) return null;
              return { Code: code, Quantity: qty == null || String(qty).trim() === "" ? 1 : qty };
            })
            .filter(Boolean);
        }

        if (!isValidArray(dataRows) || dataRows.length === 0) {
          setFileError("No valid rows found. Please ensure your file has at least two columns: Code and Quantity.");
          setJsonData(null);
          return;
        }
        setJsonData(dataRows);
        handleAddCart(dataRows);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleCallback = useCallback((errItem, addedItem) => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (addedItem > 0) {
      successMessageRef?.current?.showAlert("Item Added", `${addedItem} item(s) added to cart successfully.`);
    }
    setErrorItem(null);
    setJsonData([]);
    scrollToTop();
    navigate("/OrderDetails");
    onSuccessClose();
    return;
    // if (isValidArray(errItem)) {
    //   setErrorItem(errItem);
    // } else {
    //   setErrorItem(null);
    //   setJsonData([]);
    //   scrollToTop();
    //   navigate("/OrderDetails");
    //   onSuccessClose();
    // }
  }, []);

  const handleAddCart = (dataRows) => {
    if (isValidArray(dataRows)) {
      setIsAdding(true);
      var data = dataRows
        .map((row) => {
          var code = row.Code || row.code || row.CODE || null;
          var qty = row.Quantity || row.quantity || row.QUANTITY || null;
          if (code && qty) {
            return {
              sku: String(code),
              qty: parseInt(qty),
            };
          }
        })
        .filter((item) => item != null);
      AddtoCart(
        data,
        (...args) => {
          setIsAdding(false);
          handleCallback(...args);
        },
        (progressValue, show) => {
          setProgress(progressValue);
          setShowProgress(show);
        },
      );
      scrollToTop();
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <h3 className="quickOrder-title">Excel Upload</h3>
        <div className="excelfile-Upload mt-3 text-center">
          {/* Progress Bar overlays Upload button */}
          <img src={excelUpload} alt="Excel Upload" />
          <input
            disabled={isAdding}
            type="file"
            id="excelupload"
            onChange={handleFileUpload}
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            ref={fileInputRef}
          />
          <p>Select File to Import</p>
          <div className="acceptedFile">Must be .xlsx file using our Excel template above</div>

          {fileError && <span className="orderErrorItem">{fileError}</span>}

          <div className="button-effect quickcart-btn" style={{ width: "50%", margin: "auto" }}>
            <button
              type="button"
              id="btnAddItem"
              className="btn theme-primary w-100"
              onClick={() => fileInputRef.current && fileInputRef.current.click()}
              disabled={isAdding}
              style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              {isAdding && showProgress ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginRight: 8 }}
                  ></span>
                  Uploading... {progress}%
                </>
              ) : (
                "Upload"
              )}
            </button>
          </div>
        </div>
        <div className="sampleFile-download mt-3">
          <p>
            Enter the Order Code in <span>column "A"</span> and quantity in <span>column "B"</span>.
          </p>
          <a
            href="https://cdn.wes.com.au/wesreact/src/Sample.xls"
            target="_blank"
            className="text-decoration-underline"
          >
            Download Sample Order Sheet
          </a>
        </div>
        <div style={{ marginTop: "20px", padding: "20px" }}>
          <SuccessMessageContainer ref={successMessageRef} autoClose={false} />
          {errorItem && <ErrorItem errItem={errorItem} />}

          {jsonData && isValidArray(jsonData) && false ? (
            <Fragment>
              <div style={{ marginTop: "20px", padding: "20px" }}>
                <table
                  className="table table-hover table-bordered"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead className="table-light">
                    <tr>
                      {Object.keys(jsonData[0]).map((key) => (
                        <th key={key} className="p-2 pt-1 pb-1" style={{ fontSize: "15px" }}>
                          {key}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {jsonData.map((row, index) => (
                      <tr key={index}>
                        {Object.values(row).map((value, i) => (
                          <td key={i} className="p-2 pt-1 pb-1">
                            <div className="order-prices-list ">
                              <p>{value}</p>
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="sticky-cart-btn">
                <div className="button-effect quickcart-btn mt-3">
                  <button
                    onClick={() => handleAddCart(jsonData)}
                    id="btnAddItem"
                    className="btn theme-primary w-50"
                    disabled={!jsonData || isAdding}
                    style={{ position: "relative" }}
                  >
                    {isAdding ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          style={{ marginRight: 8 }}
                        ></span>
                        Adding...
                      </>
                    ) : (
                      "Add to Cart"
                    )}
                  </button>
                </div>
              </div>
            </Fragment>
          ) : (
            <p></p>
          )}
        </div>
      </div>
    </>
  );
};
